import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * /success — Gumroad redirects here after a completed purchase.
 * Expects ?email=... in the query string.
 *
 * Sets premium status in localStorage, then redirects to /app after 3 seconds.
 */
export default function PurchaseSuccessHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const email = searchParams.get('email');

    localStorage.setItem('buddee-userType', 'premium');
    if (email) {
      localStorage.setItem('buddee-userEmail', email);
    }

    const timer = setTimeout(() => navigate('/app'), 3000);
    return () => clearTimeout(timer);
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-800 text-white px-6">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-accent-sage mb-4">
        Welcome to Premium!!
      </h1>
      <p className="text-zinc-300 text-base sm:text-lg mb-6 max-w-xl">
        Your Buddee experience just got elevated. You now have access to all
        premium features including the Dosing Calculator, Theme Customization,
        and more.
      </p>
      <p className="text-sm text-zinc-500 italic">Redirecting to your kitchen...</p>
    </div>
  );
}
